export default {
  saveByteArray(reportName, byte) {
    var blob = new Blob([byte], { type: "application/vnd.ms-excel" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  },

  GetIsoCulture(i18nCulture) {
    var dict = {
      fr: "fr-FR",
      en: "en-US",
    };

    return dict[i18nCulture];
  },

  DownloadBytes(fileName, type, extension, data) {
    const blob = new Blob([data], {
      type: type,
    });

    var date = new Date();
    var month = date.getMonth() + 1;
    month = (month < 10 ? "0" : "") + month;
    var day = date.getDate();
    day = (day < 10 ? "0" : "") + day;

    var hours = date.getHours();
    hours = (hours < 10 ? "0" : "") + hours;
    var minutes = date.getMinutes();
    minutes = (minutes < 10 ? "0" : "") + minutes;

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}_${
      day + "-" + month + "-" + date.getFullYear() + "-" + hours + ":" + minutes
    }.${extension}`;
    link.click();
    URL.revokeObjectURL(link.href);
  },
  Download(fileName, type, data, withdate) {
    const blob = new Blob([data], {
      type: type,
    });

    var date = new Date();
    var month = date.getMonth() + 1;
    month = (month < 10 ? "0" : "") + month;
    var day = date.getDate();
    day = (day < 10 ? "0" : "") + day;

    var hours = date.getHours();
    hours = (hours < 10 ? "0" : "") + hours;
    var minutes = date.getMinutes();
    minutes = (minutes < 10 ? "0" : "") + minutes;

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    if (withdate) {
      link.download = `${fileName}_${
        day +
        "-" +
        month +
        "-" +
        date.getFullYear() +
        "-" +
        hours +
        ":" +
        minutes
      }`;
    } else {
      link.download = `${fileName}`;
    }

    link.click();
    URL.revokeObjectURL(link.href);
  },
  isObject(objValue) {
    return objValue && typeof objValue === 'object' && objValue.constructor === Object;
  },
  isEmpty(val){
    return (val === undefined || val == null || val.length <= 0) ? true : false;
},
  isNotFound(e) {
    return e.includes(".");
  },
};
